import {unwrapResult} from '@reduxjs/toolkit';
import React, {useContext} from 'react';
import {useHistory} from 'react-router-dom';

import {TIconType} from 'components/dynamic-icon';
import {SimpleActionButton} from 'components/form/components';
import {ERequestFormFormKey, RequestFormTitles} from 'components/request/request-form/request-form.constants';
import {RequestFormContext} from 'components/request/request-form/request-form.context';
import {EButtonType} from 'entities/metadata';
import {showMessage} from 'shared/utils';
import {useAppDispatch, useAppSelector} from 'store/config/hooks';
import {selectRequestData} from 'store/slices/request-slice/request-selectors';
import {removeRequest} from 'store/slices/request-slice/request-slice-thunks';
import {IRequestData, ERequestStatus} from 'store/slices/request-slice/request-slice-type';
import {isItemHasIdRequestComment} from 'store/slices/request-slice/request-slice-utils';

export interface IDeleteButtonProps {
    status: ERequestStatus;
    requestFormKey: string;
    actionTitle?: string;
    actionIcon?: string;
    buttonType?: EButtonType;
    entityName?: string;
}

export const DeleteButton = ({actionTitle, actionIcon, buttonType, requestFormKey}: IDeleteButtonProps) => {
    const dispatch = useAppDispatch();
    const history = useHistory();
    const {selectedTabKey, entityName, setSelectedTabKey} = useContext(RequestFormContext);
    const requestData = useAppSelector(selectRequestData);
    const handleChange = () => {
        const requestDataField = requestData?.[requestFormKey as keyof IRequestData];
        let commentId: string = '';

        if (isItemHasIdRequestComment(requestDataField)) {
            commentId = requestDataField.idRequestComment;
        }

        dispatch(removeRequest({commentId}))
            .then(unwrapResult)
            .then(
                () => {
                    if (selectedTabKey === ERequestFormFormKey.REQUESTS) {
                        showMessage({message: `«${RequestFormTitles?.[selectedTabKey]}» успешно удалён`});
                        history.push(`/${entityName}`);
                        return;
                    }
                    if (setSelectedTabKey) {
                        setSelectedTabKey(ERequestFormFormKey.REQUESTS);
                    }
                },
                (error) => {
                    showMessage({message: error, isError: true});
                }
            );
    };

    return (
        <SimpleActionButton
            type={buttonType || 'text'}
            title={actionTitle}
            icon={actionIcon as TIconType}
            onClick={handleChange}
        />
    );
};
